export const AVERAGE_GAMELIFT_STREAMS_INIT_TIME = 3 * 60;
export const AVERAGE_UE_INITIALIZATION_TIME = 1.5 * 60;
